import bp from '@bbl-digital/snorre/lib/globals/styles/breakpoints'
import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { mobileBreakpoint } from 'shared/constants/styles'

export const HeaderWrapper = styled.div`
  display: grid;
  grid: auto / minmax(200px, 1fr) minmax(300px, 1fr);
  justify-content: space-between;
  align-items: center;

  & div:last-child {
    justify-self: end;
  }

  @media screen and (max-width: ${bp.medium}) {
    grid: auto / 1fr;
    gap: 0.5em;
  }
`

export const ContentWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;

  width: 100%;
  & > div {
    width: 100%;
  }
`

export const ContentCSSOverride = css`
  padding: 0.5em 0;

  @media screen and (max-width: ${mobileBreakpoint}px) {
    padding: 0.5em;
  }
`

export const HeaderCSSOverride = css`
  padding: 1em 1.5em;
  background-color: #f5f5f5;
  border-radius: 15px 15px 0 0;
  border-bottom: 1px solid #d7d7d7;
`

export const HorizontalPadding = styled.div`
  padding: 0 0.5em;
`
